import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function ExchangeIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M19.4822 14.3582V8.6112C19.4822 8.12384 19.0565 7.72871 18.5312 7.72871H10.2067V4.88346C10.2067 4.10482 9.19396 3.70748 8.59212 4.25126L1.28738 10.8524C0.903759 11.1991 0.904651 11.771 1.28738 12.1169L8.59212 18.7181C9.19319 19.2612 10.2067 18.8654 10.2067 18.086V15.2407H18.5312C19.0565 15.2407 19.4822 14.8455 19.4822 14.3582Z"
        fill="currentColor"
      />
      <path
        d="M30.7126 20.8841L23.4079 14.2828C22.8069 13.7397 21.7933 14.1356 21.7933 14.915V17.7603H13.4688C12.9436 17.7603 12.5178 18.1554 12.5178 18.6428V24.3898C12.5178 24.8771 12.9436 25.2723 13.4688 25.2723H21.7933V28.1175C21.7933 28.8985 22.8096 29.2903 23.4079 28.7496L30.7126 22.1484C31.0963 21.8019 31.0954 21.23 30.7126 20.8841Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
